import { render, staticRenderFns } from "./ReportShared.vue?vue&type=template&id=6b6f6240"
import script from "./ReportShared.vue?vue&type=script&lang=js"
export * from "./ReportShared.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports